/**
 * 帮助中心内容（分类 + 常见问题）
 * ------------------------------------------------------------------
 * 单独放一个文件的原因：这些文案是「数据里的字符串」，页面上靠 $t(f.q) 渲染，
 * 抽取脚本只认 $t('字面量')，放在 .vue 的 data() 里会整段漏翻（导航的
 * 首页/功能/案例 就是这样漏了 19 个语种）。
 * 这里由 _website_i18n/extract.php 定向扫描 q:/a:/name:/desc: 字段。
 *
 * 新增或修改条目时，注意：
 *   - 中文原文就是 i18n 的 key，改动等于换 key，需要重新翻译
 *   - 文案里不要出现英文单引号，避免破坏这里的抽取正则
 *   - 只写后台真实存在的流程，不写没做的功能
 */
export const cats = [
  { key: 'start', icon: '#i-rocket', name: '开店与起步', desc: '注册、选模板、绑域名、第一件商品' },
  { key: 'theme', icon: '#i-palette', name: '店铺装修', desc: '模板、组件、配色、手机端排版' },
  { key: 'goods', icon: '#i-box', name: '商品与库存', desc: '采集、改价、规格、库存同步' },
  { key: 'order', icon: '#i-truck', name: '订单与物流', desc: '采购、打单、发货、轨迹异常' },
  { key: 'money', icon: '#i-wallet', name: '收款与结算', desc: '绑账户、余额、提现、服务费' },
  { key: 'ai', icon: '#i-horn', name: '营销与 AI', desc: 'AI 客服、AI 员工、优惠券、邮件' },
  { key: 'user', icon: '#i-user', name: '账号与权限', desc: '子账号、角色、登录、安全' },
  { key: 'api', icon: '#i-code', name: '开放接口', desc: 'API、Webhook、对接自己的系统' },
]

export const faqs = [
  {
    cat: 'start',
    q: '注册开店要准备什么？多久能跑起来？',
    a: '一个能收验证码的邮箱或手机号就能注册，不需要先有营业执照。流程是：选套餐、选模板、绑域名、传第一个商品，一般一小时内能在后台跑通一单测试订单。',
  },
  {
    cat: 'start',
    q: '店铺能不能绑自己的域名？需要备案吗？',
    a: '可以。在后台「店铺设置 → 域名」里填你的域名，按提示加两条 DNS 解析，一般十分钟生效，SSL 证书自动签发。服务器在境外，不需要国内备案；自有域名按套餐权限开放。',
  },
  {
    cat: 'theme',
    q: '模板市场里的模板怎么用？换了会不会影响商品和订单？',
    a: '模板只改变店铺外观，不动商品、订单和客户数据，随时可以换回来。应用模板后，再在装修页调首页模块和配色，保存发布后前台才生效。',
  },
  {
    cat: 'theme',
    q: '装修改完，前台看还是老样子？',
    a: '先确认改动是否已经保存并发布；再强制刷新一次前台（Ctrl 或 Cmd 加 Shift 加 R），浏览器可能缓存了旧样式。手机上还要清一下站点缓存。仍然不对，把店铺编号和页面地址发给客服。',
  },
  {
    cat: 'goods',
    q: '怎么把 1688、淘宝的商品搬到店铺里？',
    a: '在后台「商品 → 采集」里贴商品链接，选目标分类和加价规则，确认后生成商品草稿；检查图片、规格、库存再上架。带别人店铺 logo 或水印的图，建议换掉再用。',
  },
  {
    cat: 'goods',
    q: '商品价格怎么定？汇率和加价率在哪里改？',
    a: '在价格规则里配汇率和加价率，商品价格会按规则自动算；单个商品也可以在编辑页手工改价。改规则只影响之后的价格计算，已经生成的订单金额不变。',
  },
  {
    cat: 'order',
    q: '客户下单以后，我要做哪些操作？',
    a: '订单列表里能看到待采购和待发货。先按订单采购，再录入物流单号发货；单号录入后，客户在店铺前台就能看到轨迹。状态卡在某一环节时，后台会有提示。',
  },
  {
    cat: 'order',
    q: '物流轨迹一直不更新，是丢件了吗？',
    a: '单号录入后通常 24 小时内才有第一条轨迹，节假日会更慢。超过 48 小时没有更新，先核对单号和渠道有没有填错；确认无误就把订单号发给客服，由平台向渠道查件。',
  },
  {
    cat: 'order',
    q: '客户要退款，钱是从哪里退的？',
    a: '从你绑定的收款账户原路退回，平台不经手这笔钱。在订单详情点「退款」，填金额和原因，客户一般 3 到 5 个工作日收到。已经发货的订单，建议先和客户确认拒收或退回。',
  },
  {
    cat: 'money',
    q: '后台余额怎么充值？提现多久到账？',
    a: '充值在「余额」页按提示转账并提交凭证，到账后就能用于采购和扣费。提现提交后按后台显示的结算周期处理，具体时效和手续费以提现页说明为准。',
  },
  {
    cat: 'money',
    q: '平台服务费和佣金是怎么算的？在哪里看？',
    a: '按订单实付金额和你所在套餐的费率计算，账单在后台的账单与佣金页可以逐单核对。对某笔金额有疑问，带上订单号问客服，能查到具体的计费口径。',
  },
  {
    cat: 'ai',
    q: 'AI 客服答错了，怎么调整？',
    a: 'AI 客服只按你给的知识库和话术回答。答错通常是知识库缺这一条：把标准答案补进去，再实测几次。涉及价格、售后时效这类敏感问题，建议写成明确规则，让它照规则说。',
  },
  {
    cat: 'ai',
    q: '前台能显示多种语言吗？翻译不准能不能自己改？',
    a: '支持 20 种语言，访客进来会按浏览器语言自动显示对应版本。词条在后台语言包里可以直接改，改完前台即时生效；某个语种整段没翻译时，会回退显示英文。',
  },
  {
    cat: 'user',
    q: '子账号怎么开？能不能限制他只能看一部分功能？',
    a: '在「权限管理」里新增管理员并勾选他能访问的菜单，子账号登录后只看到被授权的页面，订单、提现这类敏感操作可以单独关掉。员工离职直接停用账号即可。',
  },
  {
    cat: 'user',
    q: '忘记密码 / 换了手机号，怎么找回？',
    a: '登录页点「忘记密码」，用注册邮箱收验证码重置。邮箱也收不到、或者注册手机号已经停用，就把店铺编号和注册邮箱发给客服，核验后人工处理。',
  },
  {
    cat: 'api',
    q: '能不能对接我自己的 ERP？数据怎么同步？',
    a: '可以。平台开放 REST 接口和 Webhook：用 ERP 管货的，只同步库存；用自己系统管订单的，只拉订单。接口按店铺隔离，一个 Token 只能读自己店的数据，先在沙箱环境联调。',
  },
]
